const ZipIcon = () => {
    return(
        <>
        <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-file-archive h-4 w-4"
                  >
                    <path d="M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v18"></path>
                    <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                    <circle cx="10" cy="20" r="2"></circle>
                    <path d="M10 7V6"></path>
                    <path d="M10 12v-1"></path>
                    <path d="M10 18v-2"></path>
                  </svg>
        </>
    )
}
export default ZipIcon;